module.exports = __webpack_public_path__ + "img/verify.88a1f20e.gif";